// Keep in sync with backend/src/const/user.ts PERMISSIONS.
const userPermissions = {
  CURATOR: 'curator',
  AUTHOR: 'author',
  SUPER_ADMIN: 'super_admin',
  PROXY_DISTRICT_ADMIN: 'proxy_district_admin',
  DATA_OPS: 'data_ops',
  DATA_OPS_ONLY: 'data_ops_only',
  ADMIN_LOGIN_VIA_LTI: 'admin-login-via-lti',
  INSIGHTS_ONLY: 'insights_only',
  LTI_TEACHER_WITH_ADMIN_ROLE: 'lti-teacher-with-admin-role',
  AI_QUIZ: 'ai-quiz',
  VIDEO_QUIZ: 'video-quiz',
  DISTRICT_COMMON: 'district-common',
  SCHOOL_COMMON: 'school-common',
  INSTANT_LESSON_PACKAGE: 'instant-lesson-package',
  ENABLE_DISTRICT_CONTENT_FILTER: 'enable-district-content-filter',
  ENABLE_PLAN_INTERVENTIONS: 'enable-plan-interventions',
  ENABLE_SEMANTIC_SEARCH: 'enable-semantic-search',
  GEN_AI: 'gen-ai',
  AI_SUMMARY: 'ai-summary',
  BULK_CONTENT_CONVERTER: 'bulk-content-converter',
  BULK_MOVE_CONTENT_TO_DISTRICT: 'bulk-move-content-to-district',
  CURRICULUM_IMPORT: 'curriculum-import',
  ENABLE_PLAYLIST: 'enable-playlist',
  ENABLE_PEARY_CHAT: 'enable-peary-chat',
  DISABLE_PEARY_CHAT: 'disable-peary-chat',
  ILP_BUTTON_BLACKLISTED: 'ilp-button-blacklisted',
  ALLOW_AUTO_COMPLETE: 'allow-auto-complete',
  PROFILE_REPORTS: 'profile-reports',
  SURVEY_REPORTS: 'survey-reports',
  MFA_DISABLED: 'mfa-disabled',
  AI_QUESTION_ASSISTANCE: 'ai-question-assistance',
  TEST_METADATA_ASSISTANCE: 'test-metadata-assistance',
  ENABLE_TEST_FOLDER_SHARING: 'enable-test-folder-sharing',
  ALLOW_ROSTER_PASSWORD_RESET: 'allow-roster-password-reset',
  // Edulastic admins: update the Product Updates link and notify users (ASM-993)
  MANAGE_PRODUCT_UPDATES: 'manage-product-updates',
}

module.exports = userPermissions
